import React, { useContext } from "react";
import * as Contexts from "../../../../contexts";
import { useFormContext } from "react-hook-form";
import { TBanquetForm } from "../../types";
import { PhotoWrap, Wrapper } from "./styled";
import { PhotoPicker } from "../../../../components/PhotoPicker";
import { Controller } from "react-hook-form";
import { Translater } from "../../../../config";
import { useParams } from "react-router-dom";

export const MainPhoto = () => {
  const { id } = useParams<{ id: string }>();

  const { language } = useContext(Contexts.LanguageContext);
  const {
    control,
    formState: { errors },
  } = useFormContext<TBanquetForm>();

  const isCentAur = id === "cafe-centaur";

  return (
    <Wrapper>
      <PhotoWrap>
        <Controller
          rules={{
            required: Translater?.Landings?.Banquet?.required?.[language?.slug],
          }}
          defaultValue={""}
          control={control}
          name="mainImage1"
          render={({ onChange, value }) => (
            <PhotoPicker
              headerTitle={language.slug === "uk" ? "Фото 1" : "Photo 1"}
              file={value}
              onChange={onChange}
              isHeader
              width="340px"
              height="340px"
            />
          )}
        />
        {errors?.mainImage1?.message && (
          <span>{errors.mainImage1.message.toString()}</span>
        )}
      </PhotoWrap>
      <PhotoWrap>
        <Controller
          rules={{
            required: Translater?.Landings?.Banquet?.required?.[language?.slug],
          }}
          defaultValue={""}
          control={control}
          name="mainImage2"
          render={({ onChange, value }) => (
            <PhotoPicker
              headerTitle={language.slug === "uk" ? "Фото 2" : "Photo 2"}
              file={value}
              onChange={onChange}
              isHeader
              width="340px"
              height="340px"
            />
          )}
        />{" "}
        {errors?.mainImage2?.message && (
          <span>{errors.mainImage2.message.toString()}</span>
        )}
      </PhotoWrap>
      {isCentAur && (
        <PhotoWrap>
          <Controller
            rules={{
              required:
                Translater?.Landings?.Banquet?.required?.[language?.slug],
            }}
            defaultValue={""}
            control={control}
            name="mainImage3"
            render={({ onChange, value }) => (
              <PhotoPicker
                headerTitle={language.slug === "uk" ? "Фото 3" : "Photo 3"}
                file={value}
                onChange={onChange}
                isHeader
                width="340px"
                height="340px"
              />
            )}
          />{" "}
          {errors?.mainImage3?.message && (
            <span>{errors.mainImage3.message.toString()}</span>
          )}
        </PhotoWrap>
      )}
    </Wrapper>
  );
};
